import { useTranslation } from 'react-i18next';
import * as Shared from '@shared/lib';

interface FactionInfoProps {
  className?: string;
  planet?: string;
  mission?: number;
}

export function FactionInfo(props: FactionInfoProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Factions' });

  const planetData = Shared.planetData.find((p) => p.name === props.planet);
  if (!planetData) return null;

  const missionData = planetData?.missions?.find((_, i) => i === props.mission);
  const faction = missionData?.faction || planetData.faction || 'Aegis';

  const data = Shared.factionData.find((f) => f.name === faction);
  if (!data) return null;

  const cards = Shared.cardData.filter((c) => 'faction' in c && c.faction === faction);
  if (cards.length === 0) return null;

  const getCardStyle = (key: string) => {
    if (key === 'yp442') {
      return { transform: 'scaleX(-1) translateX(20%)' };
    }

    if (['heavy', 'recon', 'ix224'].includes(key)) {
      return { transform: 'scaleX(-1)' };
    }
  };

  const containerClass = (i: number) => {
    const bottom = i === cards.length - 1 ? '' : 'border-b';
    return `${bottom}`;
  };

  return (
    <div className="factioninfo">
      <div className={`${props.className} p-2 border-b border-secondary bg-black/40`}>
        <div className="flex flex-col justify-between text-left h-full w-full">
          <div>
            <p className="text-lg leading-tight text-red-500">{t('faction')}</p>
            <p className="text-gray-300 text-sm">{t(`${data.name}.fullName`)}</p>
          </div>
          <p className="text-gray-300 text-xs italic mt-6 pr-8">
            {t(`${data.name}.lore`)}
          </p>
        </div>
      </div>

      {cards.map((card, i) => (
        <div className={`${containerClass(i)} h-36 border-secondary relative flex bg-black/40 overflow-hidden`} key={card.key}>
          <div className="absolute right-0 top-0 bottom-0 pt-2">
            <img
              className={`
                ${card.key !== 'grunt' && 'scale-x-[-1]'}
                object-cover h-full mx-auto blur-animation
              `}
              src={`/img/factions/${data.name.toLowerCase()}_${card.key}_transparent.avif`}
              style={getCardStyle(card.key)}
              alt={card.key}
            />
          </div>
          <div className="absolute bg-gradient-to-l from-black/70 to-transparent inset-0" />

          <div className="flex flex-col justify-between p-2 text-left z-10">
            <p className="text-gray-100 leading-tight">{t(`${data.name}.${card.key}`)}</p>
            <p className="text-gray-300 text-xs italic">
            {t(`${data.name}.${card.key}Description`)}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}